module.exports = __webpack_public_path__ + "static/media/cigarettes_04_thumb_hover.d028e811.png";